// extracted by mini-css-extract-plugin
module.exports = {"layout":"_0fce717cdb--layout--gNXUZ"};